const poxCodes = [
  'C34.00',
  'C34.01',
  'C34.02',
  'C34.10',
  'C34.11',
  'C34.12',
  'C34.2',
  'C34.30',
  'C34.31',
  'C34.32',
  'C34.80',
  'C34.81',
  'C34.82',
  'C34.90',
  'C34.91',
  'C34.92',
  'G47.30',
  'I01.8',
  'I09.81',
  'I11.0',
  'I13.0',
  'I13.2',
  'I16.0',
  'I16.1',
  'I16.9',
  'I50.1',
  'I50.20',
  'I50.21',
  'I50.22',
  'I50.23',
  'I50.30',
  'I50.31',
  'I50.32',
  'I50.33',
  'I50.40',
  'I50.41',
  'I50.42',
  'I50.43',
  'I50.810',
  'I50.811',
  'I50.812',
  'I50.813',
  'I50.814',
  'I50.82',
  'I50.83',
  'I50.84',
  'I50.89',
  'I50.9',
  'J43.0',
  'J43.1',
  'J43.2',
  'J43.8',
  'J43.9',
  'J44.0',
  'J44.1',
  'J44.81',
  'J44.89',
  'J44.9',
  'J4A.0',
  'J4A.8',
  'J45.20',
  'J45.21',
  'J45.22',
  'J45.30',
  'J45.31',
  'J45.32',
  'J45.40',
  'J45.41',
  'J45.42',
  'J45.50',
  'J45.51',
  'J45.52',
  'J45.901',
  'J45.902',
  'J45.909',
  'J45.990',
  'J45.991',
  'J45.998',
  'J47.1',
  'J47.9',
  'J80',
  'J84.10',
  'J95.1',
  'J95.2',
  'J95.3',
  'J95.821',
  'J95.822',
  'J96.00',
  'J96.01',
  'J96.02',
  'J96.10',
  'J96.11',
  'J96.12',
  'J96.20',
  'J96.21',
  'J96.22',
  'J98.4',
  'R06.00',
  'R06.02',
  'R06.03',
  'R06.09',
  'R06.2',
  'R06.3',
  'R06.81',
  'R06.82',
  'R06.83',
  'R06.89',
];

const hstCodes = ['G47.10', 'G47.33'];

const psgCodes = [
  'F51.3',
  'F51.4',
  'F51.5',
  'F51.8',
  'G47.10',
  'G47.11',
  'G47.12',
  'G47.30',
  'G47.31',
  'G47.33',
  'G47.34',
  'G47.35',
  'G47.36',
  'G47.37',
  'G47.39',
  'G47.411',
  'G47.419',
  'G47.421',
  'G47.429',
  'G47.50',
  'G47.51',
  'G47.52',
  'G47.53',
  'G47.54',
  'G47.59',
  'G47.61',
  'G47.8',
  'R09.02',
];

export const primaryDiagnosisCodes = {
  POX: poxCodes,
  COX: poxCodes,
  HST: hstCodes,
  PSG: psgCodes,
};
